import { render, staticRenderFns } from "./ReviewCleanupDialog.vue?vue&type=template&id=bc9e76de&"
import script from "./ReviewCleanupDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewCleanupDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports